import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { store } from 'app/store';
import { Toaster } from 'components/ui/toast/toaster';
import App from './App';
import { initGA } from './analytics/atalytics';

import './index.css';

// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from 'react-router-dom';
import PageTracker from './PageTracker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

initGA();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <PageTracker />
        <App />
        <Toaster />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// serviceWorkerRegistration.register();
